/**
 * TrustedLogos registry — one source of truth for the homepage brand strip.
 *
 * Label vocabulary (fixed, matches the audit): "Live client", "Pilot",
 * "Illustrative", "Partner". When WebsiteTech has real verified clients,
 * flip the `kind` on individual entries here — no component edit needed.
 *
 * Rules:
 *   - "Live client" and "Partner" must link to a verified case study or
 *     partner page (`caseStudySlug` or `partnerUrl`). The UI falls back
 *     to "Illustrative" if those pointers are missing.
 *   - Everything with no verifiable backing stays "Illustrative" + a
 *     disclosure line linking to /case-studies.
 */
import { Hexagon, Aperture, Boxes, Orbit, Command, Gem } from "lucide-react";

export const LOGO_KINDS = {
  "live":         { label: "Live client",  bg: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "pilot":        { label: "Pilot",        bg: "bg-sky-50 text-sky-700 border-sky-200" },
  "partner":      { label: "Partner",      bg: "bg-violet-50 text-violet-700 border-violet-200" },
  "illustrative": { label: "Illustrative", bg: "bg-amber-50 text-amber-700 border-amber-200" },
};

export const TRUSTED_LOGOS = [
  { icon: Hexagon,  name: "Northwind", kind: "illustrative" },
  { icon: Aperture, name: "Apertize",  kind: "illustrative" },
  { icon: Boxes,    name: "Stackly",   kind: "illustrative" },
  { icon: Orbit,    name: "Orbita",    kind: "illustrative" },
  { icon: Command,  name: "Cmnd",      kind: "illustrative" },
  { icon: Gem,      name: "Facet",     kind: "illustrative" },
];

/** Resolve a logo's displayed kind, downgrading to "illustrative" if the
 *  live/partner backing isn't provided. */
export function resolveLogoKind(entry) {
  if (entry.kind === "live" && !entry.caseStudySlug) return "illustrative";
  if (entry.kind === "partner" && !entry.partnerUrl) return "illustrative";
  return entry.kind || "illustrative";
}
